/**
 * Shared London Dynamics configurator helpers for blocks/image-with-3d.liquid and
 * snippets/product-swiper-gallery-3d.liquid. Loaded as a plain blocking script before
 * their inline scripts, so window.londonDynamics is there by the time either mounts.
 */
(function () {
  if (window.londonDynamics) return;

  const SCRIPT_URL = 'https://web-packages.londondynamics.com/webcomponent/v/latest/configurator.js';
  const SCRIPT_ORIGIN = 'https://web-packages.londondynamics.com';
  const CONFIGURATOR_ORIGIN = 'https://configurator.v2.londondynamics.com';
  const CUSTOMER_ID = '019e8e65-f52f-7e7a-aa83-410561f9e42c';

  let scriptFailure = null;

  // The configurator only mounts on scroll or tab open; warm up both origins and the
  // script now so that doesn't start from a cold connection.
  const addHint = (rel, href, crossOrigin) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = '';
    document.head.appendChild(link);
  };

  addHint('preconnect', SCRIPT_ORIGIN, true);
  addHint('preconnect', CONFIGURATOR_ORIGIN);
  addHint('modulepreload', SCRIPT_URL);

  /**
   * Adds the configurator script once per page. The returned promise never resolves;
   * it only rejects if the script fails, and the next call then retries.
   */
  const loadScript = () => {
    if (scriptFailure) return scriptFailure;

    scriptFailure = new Promise((_resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = SCRIPT_URL;

      script.addEventListener(
        'error',
        () => {
          script.remove();
          scriptFailure = null;
          reject(new Error('Configurator script failed to load'));
        },
        { once: true }
      );

      document.head.appendChild(script);
    });

    return scriptFailure;
  };

  const createConfigurator = (sku) => {
    const configurator = document.createElement('ld-configurator');
    configurator.setAttribute('style', 'display:block; width:100%; height:100%;');
    configurator.setAttribute('customer-id', CUSTOMER_ID);
    configurator.setAttribute('sku', sku || '');
    return configurator;
  };

  // ld-configurator re-emits every message from its origin, whichever iframe sent it,
  // so with two configurators on the page one would hear the other's "ready". Match
  // the sender against this element's own iframe instead.
  const onSettled = (configurator, callback) => {
    const handleMessage = (event) => {
      if (event.origin !== CONFIGURATOR_ORIGIN) return;
      if (!['ready', 'load', 'error'].includes(event.data?.type)) return;

      const frame = configurator.shadowRoot?.querySelector('iframe');
      if (!frame || event.source !== frame.contentWindow) return;

      window.removeEventListener('message', handleMessage);
      callback(event.data);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  };

  window.londonDynamics = { loadScript, createConfigurator, onSettled };
})();
